import { BusinessAnalyticsLayout } from "../layouts/BusinessAnalyticsLayout";
import { BusinessAnalyticsInstance } from "../utils/businessAnalyticsClass";
import { Dashboard } from "./DashboardPage";

export const AnalyticsPage = () => {
  const initializeBusinessAnalytics = async () => {
    await BusinessAnalyticsInstance.initialize();
  };

  return (
    <Dashboard header="asdf Analytics">
      <BusinessAnalyticsLayout actions={{ get: initializeBusinessAnalytics }}></BusinessAnalyticsLayout>
    </Dashboard>
  );
};
